export default () => {
  const validateTheStep = async (): Promise<boolean> => {
    return true;
  };

  return {
    validateTheStep,
  };
};
